<template>
  <div class="reimbursemnet">
    <approval
      :isBillType="isBillType"
      :departmentId="departmentId"
    />
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import Approval from "@/components/approval.vue";
export default {
  components: {
    Approval
  },

  data() {
    return {
      isBillType: 1,
      departmentId: 0,
    }
  },

  created() {
    config()
  },

  methods: {
  }
}
</script>

<style lang='scss'>
.reimbursemnet {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
